import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import {
  FaUserPlus,
  FaHandshake,
  FaEnvelopeOpenText,
  FaHeart,
  FaTrophy,
  FaCalendarCheck,
  FaGift,
  FaUsers,
  FaChartLine,
  FaPhone,
  FaMapMarkerAlt,
  FaStar,
  FaArrowRight,
  FaCheckCircle,
  FaClock,
  FaQuoteRight,
  FaCamera,
  FaMusic,
  FaUtensils,
  FaBus,
  FaHome,
  FaPalette,
  FaWineGlass,
  FaCake,
  FaChevronLeft,
  FaChevronRight
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import eventApi from '../api/events/eventApi';
import { spApi } from '../api/serviceProviders/spApi';
import '../styles/Home.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import homepanelImage1 from '../images/Test_images/manage_events.png';
import homepanelImage2 from '../images/Test_images/ecards.png';
import homepanelImage3 from '../images/Test_images/watoa_huduma.png';

const Home = () => {
  const [events, setEvents] = useState([]);
  const [watoaHuduma, setWatoaHuduma] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [h1Text, setH1Text] = useState('');
  const h1Ref = useRef(null);
  const eventsScrollContainerRef = useRef(null);
  const watoaHudumaScrollContainerRef = useRef(null);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return 'Tarehe haijabainishwa';
    const date = new Date(dateString);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  };

  const scrollContainer = (ref, direction) => {
    if (ref.current) {
      const scrollAmount = 320;
      const container = ref.current;
      if (direction === 'left') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  // Define slides data
  const slides = [
    {
      image: homepanelImage1,
      title: "Panga & Ratibu Shughuli yako, BURE!",
      description: "HarusiOnline ni mfumo unaorahisisha kupanga & kuratibu shughuli yako bure,Tuma taarifa, Pokea ahadi online, Kumbusha michango, Rekodi taarifa za fedha,Panga bajeti, kutanishwa na watoa huduma na Tuma mialiko ya kidijitali kwa wageni wako kwa click moja tu",
      buttonText: "Anza Sasa",
      icon: FaHeart
    },
    {
      image: homepanelImage2,
      title: "Kadi za Kidigitali Zisizogharimu!",
      description: "Tengeneza kadi za kidigitali (eCard) na sambaza kwa wageni wako kwa hatua nne tu rahisi, tuma mialiko kwa SMS/WhatsApp.Okoa muda na pesa wakati wa usambazaji wa kadi zako.",
      buttonText: "Jaribu Sasa",
      icon: FaEnvelopeOpenText
    },
    {
      image: homepanelImage3,
      title: "Kutafuta Watoa Huduma Kwa Urahisi",
      description: "Pata orodha ya watoa huduma na package zao, tunakukutanisha na watoa huduma wa ubora kwa ajili ya shughuli yako mf ukumbi, chakula, mziki, usafiri, mapambo na zaidi kulingana na bajeti ya shughuli yako.",
      buttonText: "Tazama Huduma",
      icon: FaHandshake
    }
  ];

  // Load data
  useEffect(() => {
    const loadData = async () => {
      const eventData = await eventApi.getPublicEvents();
      const watoaHudumaResponse = await spApi.getProviders();
      if (eventData?.events) setEvents(eventData.events);
      if (watoaHudumaResponse && watoaHudumaResponse.providers) setWatoaHuduma(watoaHudumaResponse.providers);
    };
    loadData();
  }, []);

  // Typewriter effect function
  const typeWriter = useCallback((text, speed = 50) => {
    if (!text) return;

    let i = 0;
    const type = () => {
      if (i < text.length) {
        setH1Text(prev => text.substring(0, i + 1));
        i++;
        setTimeout(type, speed);
      }
    };

    setH1Text('');
    setTimeout(type, 100);
  }, []);

  // Auto slide change
  useEffect(() => {
    const nextSlide = () => {
      if (isAnimating) return;
      setIsAnimating(true);
      setH1Text('');
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsAnimating(false);
      }, 300);
    };

    const interval = setInterval(nextSlide, 16000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSlide]);

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setH1Text('');
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setIsAnimating(false);
    }, 300);
  };

  // Start typewriter effect when slide changes
  useEffect(() => {
    const text = slides[currentSlide].title;
    typeWriter(text, 60);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSlide, typeWriter]);

  const scroll = (direction, ref) => {
    const container = ref.current;
    if (container) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="home-page">

      {/* ===== HERO SECTION ===== */}
      <section className="hero-section position-relative overflow-hidden">
        <div
          className="hero-bg-image"
          style={{
            backgroundImage: `url(${slides[currentSlide].image})`,
            opacity: 0.25
          }}
        />
        <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100"></div>

        <Container>
          <Row className="align-items-center min-vh-75 py-md-5 py-3">
            <Col lg={6} className="position-relative z-3 py-md-5 py-2">
              <div className="hero-content">
                {/* Animated Badge */}
                <div className="hero-badge mb-4">
                  <Link to="/newsletter" className="text-decoration-none">
                    <span className="badge-pill">
                      <FaTrophy className="me-2" />
                      Award Winning Platform
                    </span>
                  </Link>
                </div>

                {/* Animated Title */}
                <div className="typewriter-container mb-4">
                  <h1 ref={h1Ref} className="hero-title typewriter-h1 mb-3">
                    {h1Text}
                    <span className="cursor"></span>
                  </h1>
                </div>

                {/* Description */}
                <p className={`hero-description mb-4 ${isAnimating ? 'fade-out' : 'fade-in'}`}
                  style={{ lineHeight: '1.9', fontSize: '1.1rem', color: '#475569' }}>
                  {slides[currentSlide].description}
                </p>

                {/* CTA Buttons */}
                <div className="hero-buttons-container d-flex flex-wrap align-items-center gap-3 mb-4">
                  <Link to="/login" className="hero-btn-link">
                    <Button
                      variant="primary"
                      size="lg"
                      className="hero-cta-btn shadow-lg"
                    >
                      {slides[currentSlide].buttonText}
                      <FaArrowRight className="ms-2" />
                    </Button>
                  </Link>
                  <Link to="/about" className="hero-btn-link">
                    <Button
                      variant="outline-primary"
                      size="lg"
                      className="hero-sec-btn"
                    >
                      Jifunze Zaidi
                    </Button>
                  </Link>
                </div>

                {/* Trust indicators */}
                <div className="trust-indicators d-flex gap-4">
                  <div className="d-flex align-items-center">
                    <FaCheckCircle className="text-success me-2" />
                    <span className="small fw-bold">Bure kujiunga</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <FaClock className="text-primary me-2" />
                    <span className="small fw-bold">Pata haraka</span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6} className="position-relative z-3 d-none d-lg-block">
              <div className="hero-image-container">
                <img
                  src={slides[currentSlide].image}
                  alt="Wedding Planning"
                  className={`hero-image ${isAnimating ? 'fade-out-img' : 'fade-in-img'}`}
                />
                {/* Floating decorative elements */}
                <div className="floating-element el-1">
                  <div className="floating-icon">
                    <FaHeart className="text-danger" />
                  </div>
                </div>
                <div className="floating-element el-2">
                  <div className="floating-icon">
                    <FaCalendarCheck className="text-primary" />
                  </div>
                </div>
                <div className="floating-element el-3">
                  <div className="floating-icon">
                    <FaGift className="text-warning" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Slide Indicators */}
          <div className="carousel-indicators position-absolute bottom-0 start-50 translate-middle-x mb-4 z-3">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`indicator-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => {
                  if (!isAnimating && index !== currentSlide) {
                    setIsAnimating(true);
                    setH1Text('');
                    setTimeout(() => {
                      setCurrentSlide(index);
                      setIsAnimating(false);
                    }, 300);
                  }
                }}
              />
            ))}
          </div>
        </Container>

        {/* Wave Divider */}
        <div className="wave-divider position-absolute bottom-0 start-0 w-100">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,160L48,181.3C96,203,192,245,288,261.3C384,277,480,267,576,224C672,181,768,107,864,85.3C960,64,1056,96,1152,122.7C1248,149,1344,171,1392,181.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* ===== FEATURES SECTION ===== */}
      <Container className="my-5">
        <div className="text-center mb-5">
          <span className="section-subtitle">Kuanza ni Rahisi</span>
          <div className="section-divider"></div>
        </div>

        <Row className="my-5 g-4">
          {[
            {
              icon: FaUserPlus,
              title: "Jisajili Bure",
              text: "Anza kwa kujisajili BURE! Mratibu wa shughuli au mtoa huduma.",
              link: "/login",
              bgColor: "linear-gradient(135deg, #e6f0ff 0%, #d4e4ff 100%)",
              iconColor: "#4a85ff"
            },
            {
              icon: FaHandshake,
              title: "Tafuta Watoa Huduma",
              text: "Tizama Watoa Huduma Wetu,ili kuweza Kujipatia Mziki,Mapambo,Usafiri,Chakula.",
              link: "/WatoaHuduma",
              bgColor: "linear-gradient(135deg, #e6ffe6 0%, #d4f5d4 100%)",
              iconColor: "#10b981"
            },
            {
              icon: FaEnvelopeOpenText,
              title: "Tuma Mialiko",
              text: "Tuma mialiko ya harusi yako kwa njia ya kidigitali, na uhifadhi pesa na karatasi.",
              link: "/e_card",
              bgColor: "linear-gradient(135deg, #fff0e6 0%, #ffe8d4 100%)",
              iconColor: "#f59e0b"
            }
          ].map((item, index) => (
            <Col key={index} xs={12} sm={6} md={4} className="d-flex">
              <Card className="mb-4 shadow-sm hover-card feature-card w-100 border-0">
                <div className="feature-icon-wrapper" style={{ background: item.bgColor }}>
                  <item.icon size={40} color={item.iconColor} />
                </div>
                <Card.Body className="d-flex flex-column text-center">
                  <Card.Title className="fs-5 fw-bold mt-2">{item.title}</Card.Title>
                  <Card.Text className="flex-grow-1 text-muted">{item.text}</Card.Text>
                  <Button
                    as={Link}
                    to={item.link}
                    variant="primary"
                    size="sm"
                    className="mt-3 rounded-pill mx-auto d-block px-4"
                  >
                    Anza Sasa <FaArrowRight className="ms-1" size={12} />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* ===== SERVICES SECTION ===== */}
      <section className="services-section py-5" style={{ backgroundColor: '#f8fafc' }}>
        <Container>
          <div className="text-center mb-5">
            <span className="section-subtitle">Huduma Zetu</span>
            <h2 className="section-title fw-bold">Kila Kitu Unachohitaji kwa Shughuli Yako</h2>
            <div className="section-divider"></div>
          </div>

          <Row className="g-4">
            {[
              { icon: "bi-envelope-paper-heart", title: "Kadi za Kidigitali", description: "Badala ya kuchapa kadi za mwaliko, unaweza kutengeneza kadi nzuri za kidigitali kwa kutumia simu yako. Kadi hizi zinaweza kutumwa kwa urahisi kwa njia ya Whatsapp na SMS." },
              { icon: "bi-gift", title: "Kukumbushia Michango", description: "Fuatilia kwa urahisi michango ya wageni wako. Mfumo wetu utakutumia taarifa za kila mchango na kukukumbusha kuwashukuru wageni." },
              { icon: "bi-people", title: "Kamati", description: "Unda kamati ya harusi na uwape kila mmoja majukumu mahususi. Mfumo wetu utakusaidia kusimamia kazi zote za kamati." },
              { icon: "bi-cash-coin", title: "Ripoti za Fedha", description: "Pata muhtasari kamili wa fedha zako zote za harusi. Ripoti zetu zitakusaidia kufuatilia gharama zako." },
              { icon: "bi-globe", title: "Tovuti ya Bure", description: "Tunakupa tovuti maalum ya shughuli yako yenye 'custom domain' (mf. jane.harusi.online) ushiriki maelezo yote muhimu." },
              { icon: "bi-image", title: "Album ya Picha", description: "Shiriki picha za shughuli yako kwenye tovuti yako, wape wageni uwezo wa kushare picha za matukio." }
            ].map((service, index) => (
              <Col key={index} lg={4} md={6}>
                <div className="service-card p-4 text-center h-100">
                  <div className="service-icon-wrapper">
                    <i className={`bi ${service.icon}`}></i>
                  </div>
                  <h4 className="service-title mt-3">{service.title}</h4>
                  <p className="service-description text-muted">{service.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ===== INTERACTIVE SVG INFOGRAPHICS SECTION ===== */}
      <section className="infographics-section py-5">
        <Container>
          <div className="text-center mb-5">
            <span className="section-subtitle">Takwimu & Mwenendo</span>
            <h2 className="section-title fw-bold">Muhtasari wa Shughuli Zako</h2>
            <div className="section-divider"></div>
            <p className="text-muted mt-3">Muhtasari wa takwimu za mialiko, rsvp, na mgawanyo wa bajeti kidigitali</p>
          </div>

          <Row className="g-4">
            {/* Growth Trend Chart */}
            <Col lg={4} md={6}>
              <Card className="h-100 border-0 shadow-sm p-4 text-center hover-card bg-white infographic-card">
                <h5 className="fw-bold mb-3" style={{ color: '#1e293b' }}>
                  <FaChartLine className="me-2 text-primary" />
                  Utumaji wa Ujumbe
                </h5>
                <div style={{ position: 'relative', height: '200px' }}>
                  <svg viewBox="0 0 300 180" width="100%" height="100%">
                    {/* Grid Lines */}
                    <line x1="30" y1="30" x2="280" y2="30" stroke="#f1f5f9" strokeWidth="1" />
                    <line x1="30" y1="80" x2="280" y2="80" stroke="#f1f5f9" strokeWidth="1" />
                    <line x1="30" y1="130" x2="280" y2="130" stroke="#f1f5f9" strokeWidth="1" />
                    <line x1="30" y1="160" x2="280" y2="160" stroke="#e2e8f0" strokeWidth="1" />

                    {/* X Axis Labels */}
                    <text x="30" y="175" fill="#94a3b8" fontSize="10" textAnchor="middle">Jan</text>
                    <text x="80" y="175" fill="#94a3b8" fontSize="10" textAnchor="middle">Feb</text>
                    <text x="130" y="175" fill="#94a3b8" fontSize="10" textAnchor="middle">Mar</text>
                    <text x="180" y="175" fill="#94a3b8" fontSize="10" textAnchor="middle">Apr</text>
                    <text x="230" y="175" fill="#94a3b8" fontSize="10" textAnchor="middle">May</text>
                    <text x="280" y="175" fill="#94a3b8" fontSize="10" textAnchor="middle">Jun</text>

                    {/* Y Axis Labels */}
                    <text x="20" y="34" fill="#94a3b8" fontSize="9" textAnchor="end">120K</text>
                    <text x="20" y="84" fill="#94a3b8" fontSize="9" textAnchor="end">70K</text>
                    <text x="20" y="134" fill="#94a3b8" fontSize="9" textAnchor="end">25K</text>

                    {/* Gradient Fill under Path */}
                    <defs>
                      <linearGradient id="growthGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.35" />
                        <stop offset="100%" stopColor="#4f46e5" stopOpacity="0.0" />
                      </linearGradient>
                    </defs>
                    <path
                      d="M 30 160 Q 55 140, 80 130 T 130 90 T 180 80 T 230 45 T 280 30 L 280 160 Z"
                      fill="url(#growthGradient)"
                    />

                    {/* Curved Line */}
                    <path
                      d="M 30 160 Q 55 140, 80 130 T 130 90 T 180 80 T 230 45 T 280 30"
                      fill="none"
                      stroke="#4f46e5"
                      strokeWidth="3"
                      strokeLinecap="round"
                      className="animate-path"
                    />

                    {/* Data Points */}
                    <circle cx="30" cy="160" r="4.5" fill="#ffffff" stroke="#4f46e5" strokeWidth="2.5" />
                    <circle cx="80" cy="130" r="4.5" fill="#ffffff" stroke="#4f46e5" strokeWidth="2.5" />
                    <circle cx="130" cy="90" r="4.5" fill="#ffffff" stroke="#4f46e5" strokeWidth="2.5" />
                    <circle cx="180" cy="80" r="4.5" fill="#ffffff" stroke="#4f46e5" strokeWidth="2.5" />
                    <circle cx="230" cy="45" r="4.5" fill="#ffffff" stroke="#4f46e5" strokeWidth="2.5" />
                    <circle cx="280" cy="30" r="4.5" fill="#ffffff" stroke="#4f46e5" strokeWidth="2.5" />
                  </svg>
                </div>
                <p className="mt-3 text-muted small">Ujumbe unaotumwa kwa wageni huongezeka kwa kasi kila mwezi</p>
              </Card>
            </Col>

            {/* RSVP Distribution Chart */}
            <Col lg={4} md={6}>
              <Card className="h-100 border-0 shadow-sm p-4 text-center hover-card bg-white infographic-card">
                <h5 className="fw-bold mb-3" style={{ color: '#1e293b' }}>
                  <FaUsers className="me-2 text-primary" />
                  Mwitikio wa RSVP
                </h5>

                <div className="d-flex justify-content-around mb-3 flex-wrap" style={{ fontSize: '0.8rem' }}>
                  <div className="text-center">
                    <span className="d-inline-block rounded-circle me-1" style={{ width: 8, height: 8, backgroundColor: '#4f46e5' }}></span>
                    <span className="fw-bold" style={{ color: '#4f46e5' }}>Ndio</span>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>70%</div>
                  </div>
                  <div className="text-center">
                    <span className="d-inline-block rounded-circle me-1" style={{ width: 8, height: 8, backgroundColor: '#10b981' }}></span>
                    <span className="fw-bold" style={{ color: '#10b981' }}>Bado</span>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>20%</div>
                  </div>
                  <div className="text-center">
                    <span className="d-inline-block rounded-circle me-1" style={{ width: 8, height: 8, backgroundColor: '#f59e0b' }}></span>
                    <span className="fw-bold" style={{ color: '#f59e0b' }}>Hapana</span>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>10%</div>
                  </div>
                </div>

                <div style={{ position: 'relative', height: '170px' }}>
                  <svg viewBox="0 0 300 170" width="100%" height="100%">
                    {/* Grid Lines */}
                    <line x1="40" y1="20" x2="280" y2="20" stroke="#f1f5f9" strokeWidth="1" />
                    <line x1="40" y1="60" x2="280" y2="60" stroke="#f1f5f9" strokeWidth="1" />
                    <line x1="40" y1="100" x2="280" y2="100" stroke="#f1f5f9" strokeWidth="1" />
                    <line x1="40" y1="140" x2="280" y2="140" stroke="#cbd5e1" strokeWidth="1.5" />

                    {/* Y-Axis Labels */}
                    <text x="30" y="24" fill="#94a3b8" fontSize="9" textAnchor="end">100%</text>
                    <text x="30" y="64" fill="#94a3b8" fontSize="9" textAnchor="end">50%</text>
                    <text x="30" y="104" fill="#94a3b8" fontSize="9" textAnchor="end">25%</text>
                    <text x="30" y="144" fill="#94a3b8" fontSize="9" textAnchor="end">0</text>

                    {/* Vertical Grid Lines */}
                    <line x1="80" y1="20" x2="80" y2="140" stroke="#f1f5f9" strokeWidth="1" strokeDasharray="2 2" />
                    <line x1="160" y1="20" x2="160" y2="140" stroke="#f1f5f9" strokeWidth="1" strokeDasharray="2 2" />
                    <line x1="240" y1="20" x2="240" y2="140" stroke="#f1f5f9" strokeWidth="1" strokeDasharray="2 2" />

                    {/* X-Axis Labels */}
                    <text x="80" y="160" fill="#4f46e5" fontSize="11" fontWeight="bold" textAnchor="middle">Ndio</text>
                    <text x="160" y="160" fill="#10b981" fontSize="11" fontWeight="bold" textAnchor="middle">Bado</text>
                    <text x="240" y="160" fill="#f59e0b" fontSize="11" fontWeight="bold" textAnchor="middle">Hapana</text>

                    {/* Bars */}
                    <rect x="62" y="44" width="36" height="96" rx="4" fill="#4f46e5" />
                    <rect x="142" y="108" width="36" height="32" rx="4" fill="#10b981" />
                    <rect x="222" y="124" width="36" height="16" rx="4" fill="#f59e0b" />
                  </svg>
                </div>
                <div className="chart-footer mt-2" style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                  Ndio, Bado, Hapana (Mwitikio)
                </div>
              </Card>
            </Col>

            {/* Budget Distribution Chart */}
            <Col lg={4} md={6}>
              <Card className="h-100 border-0 shadow-sm p-4 text-center hover-card bg-white infographic-card">
                <h5 className="fw-bold mb-3" style={{ color: '#1e293b' }}>
                  <FaGift className="me-2 text-primary" />
                  Mgawanyo wa Bajeti
                </h5>

                <div style={{ position: 'relative', height: '170px' }} className="d-flex justify-content-center align-items-center">
                  <svg viewBox="0 0 200 170" width="100%" height="100%">
                    <defs>
                      <filter id="pieShadow" x="-20%" y="-20%" width="140%" height="140%">
                        <feDropShadow dx="1" dy="4" stdDeviation="3" floodOpacity="0.2" />
                      </filter>
                    </defs>

                    {/* 11 concentric segments */}
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#dc2626" strokeWidth="14"
                      strokeDasharray="113.1 377" strokeDashoffset="0" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#4f46e5" strokeWidth="14"
                      strokeDasharray="75.4 377" strokeDashoffset="-113.1" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#10b981" strokeWidth="14"
                      strokeDasharray="37.7 377" strokeDashoffset="-188.5" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#6b21a8" strokeWidth="14"
                      strokeDasharray="30.2 377" strokeDashoffset="-226.2" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#d97706" strokeWidth="14"
                      strokeDasharray="26.4 377" strokeDashoffset="-256.4" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#06b6d4" strokeWidth="14"
                      strokeDasharray="22.6 377" strokeDashoffset="-282.8" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#ec4899" strokeWidth="14"
                      strokeDasharray="18.9 377" strokeDashoffset="-305.4" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#84cc16" strokeWidth="14"
                      strokeDasharray="15.1 377" strokeDashoffset="-324.3" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#f43f5e" strokeWidth="14"
                      strokeDasharray="15.1 377" strokeDashoffset="-339.4" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#a855f7" strokeWidth="14"
                      strokeDasharray="11.3 377" strokeDashoffset="-354.5" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />
                    <circle cx="100" cy="85" r="60" fill="transparent" stroke="#64748b" strokeWidth="14"
                      strokeDasharray="11.3 377" strokeDashoffset="-365.8" style={{ filter: 'url(#pieShadow)' }} transform="rotate(-90 100 85)" />

                    {/* Center Info */}
                    <circle cx="100" cy="85" r="42" fill="#ffffff" />
                    <text x="100" y="82" textAnchor="middle" fill="#1e293b" fontSize="9" fontWeight="bold">TZS 15.0M</text>
                    <text x="100" y="94" textAnchor="middle" fill="#64748b" fontSize="8">Jumla</text>
                  </svg>
                </div>

                {/* Legend */}
                <div className="d-flex flex-wrap justify-content-center gap-2 mt-3" style={{ fontSize: '0.7rem', maxHeight: '110px', overflowY: 'auto' }}>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#dc2626' }}></span> Chakula (30%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#4f46e5' }}></span> Ukumbi (20%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#10b981' }}></span> Mapambo (10%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#6b21a8' }}></span> Vinywaji (8%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#d97706' }}></span> Picha (7%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#06b6d4' }}></span> Usafiri (6%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#ec4899' }}></span> Muziki (5%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#84cc16' }}></span> MC (4%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#f43f5e' }}></span> Keki (4%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#a855f7' }}></span> Maids (3%)</span>
                  <span className="badge bg-light text-dark border"><span className="d-inline-block rounded-circle me-1" style={{ width: 6, height: 6, backgroundColor: '#64748b' }}></span> Mengine (3%)</span>
                </div>
                <div className="chart-footer mt-2" style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                  Sehemu za matumizi kulingana na vipaumbele
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ===== STATISTICS SECTION ===== */}
      <section className="statistics-section py-5">
        <Container>
          <Row className="text-center align-items-center justify-content-center g-4">
            <div className="col-lg col-md-4 col-6">
              <div className="stat-item">
                <h2 className="stat-number">3,000+</h2>
                <p className="stat-label">Shughuli</p>
              </div>
            </div>
            <div className="col-lg col-md-4 col-6">
              <div className="stat-item">
                <h2 className="stat-number">50,000+</h2>
                <p className="stat-label">Mialiko</p>
              </div>
            </div>
            <div className="col-lg col-md-4 col-6">
              <div className="stat-item">
                <h2 className="stat-number">500+</h2>
                <p className="stat-label">Watoa Huduma</p>
              </div>
            </div>
            <div className="col-lg col-md-4 col-6">
              <div className="stat-item">
                <h2 className="stat-number">7+</h2>
                <p className="stat-label">Miaka ya Huduma</p>
              </div>
            </div>
            <div className="col-lg col-md-4 col-6">
              <div className="stat-item">
                <h2 className="stat-number">600K+</h2>
                <p className="stat-label">Ujumbe</p>
              </div>
            </div>
          </Row>
        </Container>
      </section>

      {/* ===== EVENTS SECTION - UPDATED ===== */}
      <Container className="py-4">
        <Row>
          <Col md={12}>
            <div className="events-container position-relative">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <span className="section-subtitle">Events</span>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex gap-2">
                    <Button
                      variant="light"
                      className="rounded-circle border d-flex align-items-center justify-content-center"
                      style={{ width: '40px', height: '40px', padding: 0 }}
                      onClick={() => scrollContainer(eventsScrollContainerRef, 'left')}
                      title="Sogeza Kushoto"
                    >
                      <FaChevronLeft size={16} />
                    </Button>
                    <Button
                      variant="light"
                      className="rounded-circle border d-flex align-items-center justify-content-center"
                      style={{ width: '40px', height: '40px', padding: 0 }}
                      onClick={() => scrollContainer(eventsScrollContainerRef, 'right')}
                      title="Sogeza Kulia"
                    >
                      <FaChevronRight size={16} />
                    </Button>
                  </div>
                  <Button as={Link} to="/events" variant="primary" className="rounded-pill px-4 view-all-btn">
                    Tazama Zote <FaArrowRight className="ms-1" size={12} />
                  </Button>
                </div>
              </div>

              <div className="events-scroll" ref={eventsScrollContainerRef}>
                {events.map((event) => {
                  const eventTitle = event.event_title || 'untitled-event';
                  const rawWebsiteUrl = event.full_website_url || event.full_url || event.website_url;

                  let eventUrl = '';
                  if (rawWebsiteUrl && (rawWebsiteUrl.startsWith('http://') || rawWebsiteUrl.startsWith('https://'))) {
                    eventUrl = rawWebsiteUrl;
                  } else {
                    const slugSource = rawWebsiteUrl || eventTitle;
                    const cleanSlug = slugSource
                      .replace(/^https?:\/\//, '')
                      .replace(/\/.*$/, '')
                      .replace(/\.harusi\.online.*$/i, '')
                      .replace(/\.harusionline\.co\.tz.*$/i, '')
                      .toLowerCase()
                      .replace(/[^a-z0-9]/g, '');
                    eventUrl = `https://${cleanSlug}.harusi.online/`;
                  }

                  return (
                    <div className="event-card" key={event.id}>
                      <Card className="shadow-sm border-0 h-100 event-card-modern">
                        <div className="event-image-wrapper">
                          <img
                            src={event.wallpaper?.md_photo || '/images/placeholder.jpg'}
                            alt={eventTitle}
                            className="event-card-img"
                          />
                        </div>
                        <Card.Body>
                          <h5 className="event-card-title">{eventTitle}</h5>
                          <div className="event-meta">
                            <div className="event-date-display">
                              <FaCalendarCheck className="me-2 text-primary" size={14} />
                              <span className="event-date-text">{formatDate(event.event_date)}</span>
                            </div>
                            <a href={eventUrl} target="_blank" rel="noopener noreferrer" className="event-view-link">
                              View <FaArrowRight className="ms-1" size={10} />
                            </a>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* ===== SERVICE PROVIDERS SECTION - UPDATED ===== */}
      <Container className="py-4">
        <Row>
          <Col md={12}>
            <div className="events-container position-relative">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <span className="section-subtitle">Watoa Huduma</span>
                </div>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex gap-2">
                    <Button
                      variant="light"
                      className="rounded-circle border d-flex align-items-center justify-content-center"
                      style={{ width: '40px', height: '40px', padding: 0 }}
                      onClick={() => scrollContainer(watoaHudumaScrollContainerRef, 'left')}
                      title="Sogeza Kushoto"
                    >
                      <FaChevronLeft size={16} />
                    </Button>
                    <Button
                      variant="light"
                      className="rounded-circle border d-flex align-items-center justify-content-center"
                      style={{ width: '40px', height: '40px', padding: 0 }}
                      onClick={() => scrollContainer(watoaHudumaScrollContainerRef, 'right')}
                      title="Sogeza Kulia"
                    >
                      <FaChevronRight size={16} />
                    </Button>
                  </div>
                  <Button as={Link} to="/WatoaHuduma" variant="primary" className="rounded-pill px-4 view-all-btn">
                    Tazama Wote <FaArrowRight className="ms-1" size={12} />
                  </Button>
                </div>
              </div>

              <div className="events-scroll" ref={watoaHudumaScrollContainerRef}>
                {watoaHuduma.map((provider) => (
                  <div className="event-card" key={provider.id}>
                    <Card className="shadow-sm border-0 h-100 event-card-modern">
                      <div className="event-image-wrapper">
                        <img
                          src={provider.wallpaper?.md_photo || '/images/placeholder.jpg'}
                          alt={provider.name || 'Service Provider'}
                          className="event-card-img"
                        />
                        {provider.rating && (
                          <div className="provider-rating">
                            <FaStar className="text-warning" />
                            <span>{provider.rating}</span>
                          </div>
                        )}
                      </div>
                      <Card.Body className="d-flex flex-column justify-content-between">
                        <h5 className="event-card-title">{provider.name || 'Unknown Provider'}</h5>
                        <div className="d-flex flex-column align-items-start mt-2 w-100">
                          <div className="provider-location mb-2 d-flex align-items-center w-100">
                            <FaMapMarkerAlt className="me-2 text-muted" size={12} />
                            <span className="event-date-text text-truncate">{provider.location || 'Location not specified'}</span>
                          </div>
                          <Link to={`/watoa-huduma-details/${provider.id}`} state={{ provider }} className="event-view-link text-center w-100 d-block py-2">
                            Profile <FaArrowRight className="ms-1" size={12} />
                          </Link>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>

    </div>
  );
};

export default Home;